/**
 * İzin kapısı — GÖRÜNÜRLÜK için.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * ⚠️ BU BİR GÜVENLİK KONTROLÜ DEĞİLDİR.
 *
 * Tarayıcıda çalışan hiçbir kontrol güvenlik sağlamaz: kullanıcı isteği elle
 * de gönderebilir, JavaScript'i değiştirebilir. Buradaki iş yalnız DENEYİM —
 * yetkisi olmayan kişiye basamayacağı düğmeyi göstermemek.
 *
 * ASIL KAPI SUNUCUDADIR: `role_permissions` + RLS politikaları. Bu not
 * burada, ileride biri "istemci zaten kontrol ediyor" diye sunucu tarafını
 * atlamasın diye duruyor.
 *
 * İzin listesi de sunucudan gelir (`/auth/me`) — istemcide hesaplanmaz.
 * ═══════════════════════════════════════════════════════════════════════════
 */
import type { ReactNode } from 'react';

import { izinVar, useSession } from './session.ts';

export interface YetkiProps {
  /** İzin kodu — `SEED_PERMISSIONS`'taki kodlarla aynı. */
  readonly gerekli: string;
  readonly children: ReactNode;
  /**
   * İzin yoksa gösterilecek şey. Varsayılan HİÇBİR ŞEY.
   *
   * "Yetkiniz yok" yazısı çoğu yerde gürültüdür — kullanıcı olmayan bir
   * özelliği merak etmez. Ama bazı yerlerde (boş bir liste, kapalı bir sekme)
   * sebebini söylemek gerekir; orada `yoksa` verilir.
   */
  readonly yoksa?: ReactNode;
}

export function Yetki({ gerekli, children, yoksa = null }: YetkiProps): React.JSX.Element {
  const { data: session } = useSession();
  return <>{izinVar(session, gerekli) ? children : yoksa}</>;
}

/** Koşullu mantık için — JSX yerine değer gerektiğinde. */
export function useIzin(gerekli: string): boolean {
  const { data: session } = useSession();
  return izinVar(session, gerekli);
}
